import { createFileRoute } from '@tanstack/react-router';

import { ConversationList } from '../../../../../components/ConversationList.js';
import styles from '../../../../../components/conversations.module.css';
import { useConversationsSection } from '../../../../../conversations/section.js';
import { useIsListDetailPane } from '../../../../../frame/breakpoints.js';

/**
 * `/websites/:websiteId/conversations`. At 1180px and wider the list sits in
 * the layout and this fills the pane with nothing selected; below, this is the
 * list itself, the whole view (`features/website-conversations/technical.md`,
 * Routing).
 */
export const Route = createFileRoute('/_app/websites/$websiteId/conversations/')({
  component: ConversationsIndex,
});

function ConversationsIndex() {
  const isPane = useIsListDetailPane();
  const { websiteId, page, goToPage, openedId, setOpenedId } = useConversationsSection();

  if (isPane) {
    return (
      <div className={styles.paneEmpty}>
        <p>Select a conversation to read it.</p>
      </div>
    );
  }

  return (
    <div className={styles.standalone}>
      <ConversationList
        websiteId={websiteId}
        page={page}
        onPageChange={goToPage}
        onOpen={setOpenedId}
        restoreFocusTo={openedId}
        onFocusRestored={() => setOpenedId(null)}
      />
    </div>
  );
}
